import { render } from "./ViewPracticePhoneticTranscription.vue?vue&type=template&id=558a8942&scoped=true"
import script from "./ViewPracticePhoneticTranscription.vue?vue&type=script&lang=js"
export * from "./ViewPracticePhoneticTranscription.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-phonetic-transcription.css?vue&type=style&index=0&id=558a8942&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558a8942"]])

export default __exports__